module.exports = __webpack_public_path__ + "img/circle-check-green-big-success.073185c.svg";